<template>
    <div class="modal fade" tabindex="-1" aria-labelledby="taxModalLabel" aria-hidden="true" :id="id">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content border-0 shadow">
                <!-- ヘッダー -->
                <div class="modal-header bg-info bg-gradient text-white border-bottom-0 pb-2">
                    <h5 class="modal-title fw-bold">
                        <i :class="category.id ? 'fa-solid fa-pen-to-square' : 'fa-solid fa-plus-circle'" class="me-2"></i>
                        {{ category.id ? '税区分編集' : '新規税区分作成' }}
                    </h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>

                <!-- ボディ -->
                <div class="modal-body px-4 py-3">
                    <!-- グローバルエラー -->
                    <div v-if="error.global" class="alert alert-danger d-flex align-items-start mb-3">
                        <i class="fa-solid fa-circle-exclamation me-2 mt-1"></i>
                        <span>{{ error.global }}</span>
                    </div>

                    <!-- 税区分名称 -->
                    <div class="mb-3">
                        <label class="form-label text-muted small mb-2">
                            <i class="fa-solid fa-tag me-1"></i>税区分名称
                            <span class="text-danger">*</span>
                        </label>
                        <div class="input-group">
                            <span class="input-group-text bg-light border-end-0">
                                <i class="fa-solid fa-percent text-muted"></i>
                            </span>
                            <input
                                type="text"
                                class="form-control border-start-0"
                                v-model="category.name"
                                :class="{'is-invalid': error.name}"
                                placeholder="例: 課税売上10%"
                                required
                                data-error-key="name"
                            >
                        </div>
                        <div v-if="error.name" class="text-danger small mt-1">
                            <i class="fa-solid fa-circle-info me-1"></i>{{ error.name }}
                        </div>
                    </div>

                    <!-- TKCコード -->
                    <div class="mb-3">
                        <label class="form-label text-muted small mb-2">
                            <i class="fa-solid fa-barcode me-1"></i>TKCコード
                            <span class="text-danger">*</span>
                        </label>
                        <div class="input-group">
                            <span class="input-group-text bg-light border-end-0">
                                <i class="fa-solid fa-hashtag text-muted"></i>
                            </span>
                            <input
                                type="number"
                                class="form-control border-start-0"
                                v-model="category.tkc_code"
                                :class="{'is-invalid': error.tkc_code}"
                                placeholder="例: 10"
                                required
                                data-error-key="tkc_code"
                            >
                        </div>
                        <div v-if="error.tkc_code" class="text-danger small mt-1">
                            <i class="fa-solid fa-circle-info me-1"></i>{{ error.tkc_code }}
                        </div>
                    </div>
                </div>

                <!-- フッター -->
                <div class="modal-footer border-top-0 pt-2 px-4">
                    <button type="button" class="btn btn-outline-secondary" @click="close">
                        <i class="fa-solid fa-xmark me-2"></i>キャンセル
                    </button>
                    <button type="button" class="btn btn-primary" @click="save()">
                        <i class="fa-solid fa-floppy-disk me-2"></i>保存
                    </button>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
export default {
    props: {
        id: {
            type: String,
            default: 'tax-category-editor'
        },
        tax_category_id: {
            type: Number,
            default: null
        }
    },
    data() {
        return {
            category: {},
            error: {},
        };
    },
    methods: {
        close() {
            this.$emit('close', this.id);
        },
        reload() {
            if (!this.tax_category_id) {
                this.category = {};
                return;
            }
            axios.get(`/api/master/tax-category?id=${this.tax_category_id}`).then(res => {
                this.category = res.data;
            }).catch(err => {
                Alert.err(err);
            });
        },
        validate() {
            this.error = {};
            if (!this.category.tkc_code) this.error.tkc_code = 'TKCコードは必須です。';
            if (!this.category.name) this.error.name = '税区分名称は必須です。';
            return Object.keys(this.error).length === 0;
        },
        save() {
            if (!this.validate()) { return; }

            axios.post('/api/master/tax-category', this.category).then(() => {
                Alert.msg('保存しました。');
                this.$emit('saved');
                this.close();
            }).catch(err => {
                Alert.err(err);
            });
        }
    },
    mounted() {
        $(`#${this.id}`).on("show.bs.modal", (e) => {
            this.reload();
        });
    },
}
</script>
